import {compact} from "@pg-mono/nodash";
import {PRICES_CITIES} from "@pg-rp/navigation";

import {PRICES_HUB_TRANSACTION_EXCLUDED_CITY_SLUGS} from "../constants/prices_hub_cities";
import {TRANSACTION_PRICES_MIN_TRANSACTIONS, TRANSACTION_PRICES_UNIT} from "../constants/transaction_prices";
import {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";
import {RcnPriceStatsUnit} from "../types/IRcnPriceStats";
import {ITransactionPrice} from "../types/ITransactionPrice";
import {getPeriodOfferPriceM2} from "./get_period_offer_price_m2";

export interface ITransactionPriceRow {
    slug: string;
    name: string;
    offerPriceM2: number;
    periodOfferPriceM2: number | null;
    transactionPriceM2: number;
    differencePct: number;
    /** Unit both prices in this row are expressed in. */
    unit: RcnPriceStatsUnit;
    periodStart: string;
    periodLabel: string;
    transactionsCount: number;
}

// The whole offer, matching the registry's all-rooms aggregate on the transaction side. The per-rooms
// avg_price_m2_* buckets stay unused here - picking one would narrow only half of the comparison.
// The unit has to match too: a per-m² transaction price against a whole-flat offer price is not a ratio.
const getOfferPrice = (cityData: IPriceReportAveragePrices, unit: RcnPriceStatsUnit): number => (unit === "total" ? cityData.avg_price : cityData.avg_price_m2);

export const getTransactionPriceRows = (
    citiesData: IPriceReportAveragePrices[] | null,
    transactionPrices: ITransactionPrice[],
    citiesDataHistory: IPriceReportAveragePrices[] | null = null
): ITransactionPriceRow[] => {
    if (!citiesData || citiesData.length === 0 || transactionPrices.length === 0) {
        return [];
    }

    const tableCities = PRICES_CITIES.filter((city) => !PRICES_HUB_TRANSACTION_EXCLUDED_CITY_SLUGS.includes(city.slug));

    const rows = tableCities.map((city): ITransactionPriceRow | null => {
        const cityData = citiesData.find((data) => data.slug_city === city.slug);
        const transactionPrice = transactionPrices.find((price) => price.slug === city.slug);

        if (!cityData || !transactionPrice) {
            return null;
        }

        const unit = transactionPrice.unit ?? TRANSACTION_PRICES_UNIT;
        const offerPriceM2 = Number(getOfferPrice(cityData, unit));
        const transactionPriceM2 = Number(transactionPrice.medianPriceM2);
        const transactionsCount = Number(transactionPrice.transactionsCount);

        if (!(offerPriceM2 > 0) || !(transactionPriceM2 > 0) || !(transactionsCount >= TRANSACTION_PRICES_MIN_TRANSACTIONS)) {
            return null;
        }

        const periodOfferPriceM2 = getPeriodOfferPriceM2({
            history: citiesDataHistory,
            filter: (monthData) => monthData.slug_city === city.slug,
            periodStart: transactionPrice.periodStart,
            periodLabel: transactionPrice.periodLabel,
            getPriceM2: (monthData) => getOfferPrice(monthData, unit),
            getWeight: (monthData) => monthData.available_offers
        });

        // Negotiating room means "what buyers paid against what was being asked at the time", so the
        // baseline has to be the offer price of the transaction's own quarter. Today's price is a
        // different period: a city whose quarter fell back reads as a far deeper discount than it was -
        // Gdansk showed -41.1% against today's 18 491 vs -37.8% against its own quarter's 17 517.
        const baselineOfferPriceM2 = periodOfferPriceM2 && periodOfferPriceM2 > 0 ? periodOfferPriceM2 : offerPriceM2;

        return {
            slug: city.slug,
            name: city.name,
            offerPriceM2,
            periodOfferPriceM2,
            transactionPriceM2,
            unit,
            differencePct: Math.round(((transactionPriceM2 - baselineOfferPriceM2) / baselineOfferPriceM2) * 1000) / 10,
            periodStart: transactionPrice.periodStart,
            periodLabel: transactionPrice.periodLabel,
            transactionsCount
        };
    });

    return compact(rows).sort((prev, next) => prev.differencePct - next.differencePct);
};
import {compact} from "@pg-mono/nodash";
import {PRICES_CITIES} from "@pg-rp/navigation";

import {PRICES_HUB_TRANSACTION_EXCLUDED_CITY_SLUGS} from "../constants/prices_hub_cities";
import {TRANSACTION_PRICES_MIN_TRANSACTIONS, TRANSACTION_PRICES_UNIT} from "../constants/transaction_prices";
import {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";
import {RcnPriceStatsUnit} from "../types/IRcnPriceStats";
import {ITransactionPrice} from "../types/ITransactionPrice";
import {getPeriodOfferPriceM2} from "./get_period_offer_price_m2";

export interface ITransactionPriceRow {
    slug: string;
    name: string;
    offerPriceM2: number;
    periodOfferPriceM2: number | null;
    transactionPriceM2: number;
    differencePct: number;
    /** Unit both prices in this row are expressed in. */
    unit: RcnPriceStatsUnit;
    periodStart: string;
    periodLabel: string;
    transactionsCount: number;
}

// The whole offer, matching the registry's all-rooms aggregate on the transaction side. The per-rooms
// avg_price_m2_* buckets stay unused here - picking one would narrow only half of the comparison.
// The unit has to match too: a per-m² transaction price against a whole-flat offer price is not a ratio.
const getOfferPrice = (cityData: IPriceReportAveragePrices, unit: RcnPriceStatsUnit): number => (unit === "total" ? cityData.avg_price : cityData.avg_price_m2);

export const getTransactionPriceRows = (
    citiesData: IPriceReportAveragePrices[] | null,
    transactionPrices: ITransactionPrice[],
    citiesDataHistory: IPriceReportAveragePrices[] | null = null
): ITransactionPriceRow[] => {
    if (!citiesData || citiesData.length === 0 || transactionPrices.length === 0) {
        return [];
    }

    const tableCities = PRICES_CITIES.filter((city) => !PRICES_HUB_TRANSACTION_EXCLUDED_CITY_SLUGS.includes(city.slug));

    const rows = tableCities.map((city): ITransactionPriceRow | null => {
        const cityData = citiesData.find((data) => data.slug_city === city.slug);
        const transactionPrice = transactionPrices.find((price) => price.slug === city.slug);

        if (!cityData || !transactionPrice) {
            return null;
        }

        const unit = transactionPrice.unit ?? TRANSACTION_PRICES_UNIT;
        const offerPriceM2 = Number(getOfferPrice(cityData, unit));
        const transactionPriceM2 = Number(transactionPrice.medianPriceM2);
        const transactionsCount = Number(transactionPrice.transactionsCount);

        if (!(offerPriceM2 > 0) || !(transactionPriceM2 > 0) || !(transactionsCount >= TRANSACTION_PRICES_MIN_TRANSACTIONS)) {
            return null;
        }

        const periodOfferPriceM2 = getPeriodOfferPriceM2({
            history: citiesDataHistory,
            filter: (monthData) => monthData.slug_city === city.slug,
            periodStart: transactionPrice.periodStart,
            periodLabel: transactionPrice.periodLabel,
            getPriceM2: (monthData) => getOfferPrice(monthData, unit),
            getWeight: (monthData) => monthData.available_offers
        });

        // Negotiating room means "what buyers paid against what was being asked at the time", so the
        // baseline has to be the offer price of the transaction's own quarter. Today's price is a
        // different period: a city whose quarter fell back reads as a far deeper discount than it was -
        // Gdansk showed -41.1% against today's 18 491 vs -37.8% against its own quarter's 17 517.
        const baselineOfferPriceM2 = periodOfferPriceM2 && periodOfferPriceM2 > 0 ? periodOfferPriceM2 : offerPriceM2;

        return {
            slug: city.slug,
            name: city.name,
            offerPriceM2,
            periodOfferPriceM2,
            transactionPriceM2,
            unit,
            differencePct: Math.round(((transactionPriceM2 - baselineOfferPriceM2) / baselineOfferPriceM2) * 1000) / 10,
            periodStart: transactionPrice.periodStart,
            periodLabel: transactionPrice.periodLabel,
            transactionsCount
        };
    });

    return compact(rows).sort((prev, next) => prev.differencePct - next.differencePct);
};
